import React from "react";
import { AuditLogsTable } from "./";

export const AuditLogsView: React.FC = () => {
    return <AuditLogsTable />;
};
